import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const DisputeSupport: React.FC = () => {
  const content = (
    <>
      <h2>Tvister og support</h2>
      <p>
        Når du og en anden bruger ikke kan blive enige, kan DoMore hjælpe med at mægle og finde en løsning.
      </p>

      <h3>Hvornår skal du kontakte support?</h3>
      <p>
        Kontakt DoMore support når:
      </p>
      <ul>
        <li>Du har forsøgt at løse problemet direkte uden held</li>
        <li>Den anden part ikke svarer på beskeder</li>
        <li>Der er uenighed om fakta eller aftaler</li>
        <li>Du har mistanke om svindel eller misbrug</li>
        <li>Du har brug for objektiv vurdering</li>
        <li>Situationen eskalerer</li>
      </ul>

      <h3>Før du kontakter support</h3>
      <p>
        Prøv først at løse det direkte:
      </p>
      <ol>
        <li><strong>Kommunikér åbent:</strong> Forklar dit synspunkt roligt</li>
        <li><strong>Lyt til den anden part:</strong> Forstå deres perspektiv</li>
        <li><strong>Revisér jeres aftale:</strong> Tjek chat-historik i DoMore</li>
        <li><strong>Foreslå kompromis:</strong> Find en mellemvej</li>
        <li><strong>Giv tid:</strong> Nogle gange løser ting sig selv</li>
      </ol>

      <h3>Almindelige tvist-typer</h3>

      <h4>Betalingstyper</h4>
      <p>
        Uenighed omkring:
      </p>
      <ul>
        <li>Om betaling er sket</li>
        <li>Hvor meget der skal betales</li>
        <li>Hvornår betaling skulle ske</li>
        <li>Depositum returnering</li>
      </ul>
      <p>
        <strong>Løsning:</strong> Dokumentation er nøglen. Bank/MobilePay historik, screenshots, kvitteringer.
      </p>

      <h4>Værktøjets tilstand</h4>
      <p>
        Uenighed om:
      </p>
      <ul>
        <li>Om skade skete under leje</li>
        <li>Værktøjets tilstand ved afhentning vs. returnering</li>
        <li>Normal slitage vs. misbrug</li>
        <li>Rengøringsstandard</li>
      </ul>
      <p>
        <strong>Løsning:</strong> Billeder fra både afhentning og returnering er afgørende.
      </p>

      <h4>Booking detaljer</h4>
      <p>
        Uenighed om:
      </p>
      <ul>
        <li>Afhentnings-/returner ingstidspunkt</li>
        <li>Hvad der var inkluderet i lejen</li>
        <li>Betingelser der blev aftalt</li>
        <li>Hvad der blev lovet</li>
      </ul>
      <p>
        <strong>Løsning:</strong> DoMore chat-historik er officiel dokumentation.
      </p>

      <h4>Manglende opfølgning</h4>
      <p>
        Den anden part:
      </p>
      <ul>
        <li>Dukkede ikke op</li>
        <li>Svarer ikke på beskeder</li>
        <li>Returnerede ikke værktøj</li>
        <li>Har ikke betalt som aftalt</li>
      </ul>
      <p>
        <strong>Løsning:</strong> Give rimelig tid (24-48 timer), derefter kontakt support.
      </p>

      <h3>Sådan kontakter du support</h3>

      <h4>Via DoMore appen</h4>
      <ol>
        <li>Gå til din profil</li>
        <li>Tryk på "Hjælp & Support"</li>
        <li>Vælg "Kontakt support"</li>
        <li>Vælg tvist-kategori</li>
        <li>Beskriv problemet</li>
        <li>Vedhæft dokumentation</li>
        <li>Send</li>
      </ol>

      <h4>Via email</h4>
      <p>
        Send til: <strong>support@domore.dk</strong>
      </p>
      <p>
        Inkludér:
      </p>
      <ul>
        <li>Dit brugernavn</li>
        <li>Booking ID</li>
        <li>Den anden brugers navn</li>
        <li>Detaljeret beskrivelse</li>
        <li>Al relevant dokumentation</li>
      </ul>

      <h3>Hvad skal du inkludere?</h3>
      <p>
        For at vi kan hjælpe effektivt, medgiv:
      </p>

      <h4>Grundlæggende information</h4>
      <ul>
        <li>Booking ID (find i "Mine bookinger")</li>
        <li>Datoer (hvornår skete det)</li>
        <li>Navne på involverede brugere</li>
        <li>Værktøjet det drejer sig om</li>
      </ul>

      <h4>Dokumentation</h4>
      <ul>
        <li>Screenshots af relevante beskeder</li>
        <li>Billeder af værktøj (hvis relevant)</li>
        <li>Bevis for betaling eller mangel på samme</li>
        <li>Bogning-detaljer fra DoMore</li>
        <li>Tidslinje over hvad der skete</li>
      </ul>

      <h4>Din side af historien</h4>
      <ul>
        <li>Hvad du mener der skete</li>
        <li>Hvad du forventede</li>
        <li>Hvordan du har forsøgt at løse det</li>
        <li>Hvad du ønsker som resultat</li>
      </ul>

      <h3>Hvad sker der efter du kontakter os?</h3>

      <h4>Trin 1: Modtagelse (inden 24 timer)</h4>
      <ul>
        <li>Du får bekræftelse på at vi har modtaget din henvendelse</li>
        <li>Tildelt et sagsnummer</li>
        <li>Estimeret svartid</li>
      </ul>

      <h4>Trin 2: Undersøgelse (1-3 hverdage)</h4>
      <ul>
        <li>Vi gennemgår al dokumentation</li>
        <li>Tjekker booking-detaljer i systemet</li>
        <li>Læser chat-historik mellem jer</li>
        <li>Kontakter eventuelt den anden part</li>
        <li>Kan spørge dig om yderligere information</li>
      </ul>

      <h4>Trin 3: Vurdering</h4>
      <ul>
        <li>Vi analyserer begge sider</li>
        <li>Vurderer hvem der har ret baseret på dokumentation</li>
        <li>Tjekker om der blev brudt regler</li>
        <li>Overvejer passende løsning</li>
      </ul>

      <h4>Trin 4: Løsningsforslag</h4>
      <ul>
        <li>Vi foreslår en fair løsning</li>
        <li>Forklarer vores ræsonnement</li>
        <li>Beder begge parter om accept</li>
      </ul>

      <h4>Trin 5: Opfølgning</h4>
      <ul>
        <li>Sikrer løsningen implementeres</li>
        <li>Lukker sagen når begge er tilfredse</li>
        <li>Opdaterer bruger-ratings hvis nødvendigt</li>
      </ul>

      <h3>Mulige udfald</h3>

      <h4>Favorabel for dig</h4>
      <p>
        Hvis dokumentationen støtter dig:
      </p>
      <ul>
        <li>Vi anbefaler den anden part imødekommer dine krav</li>
        <li>Deres rating kan påvirkes negativt</li>
        <li>Ved gentagne overtrædelser: advarsel eller bandlysning</li>
      </ul>

      <h4>Favorabel for den anden part</h4>
      <p>
        Hvis dokumentationen ikke støtter dig:
      </p>
      <ul>
        <li>Vi forklarer hvorfor</li>
        <li>Giver råd om hvordan du undgår fremtidige problemer</li>
        <li>Din rating kan påvirkes hvis du handlede forkert</li>
      </ul>

      <h4>Kompromis</h4>
      <p>
        Hvis begge har et punkt:
      </p>
      <ul>
        <li>Vi foreslår en løsning der møder jer halvvejs</li>
        <li>F.eks. delvis depositum returnering</li>
        <li>Begge må give lidt</li>
      </ul>

      <h4>Utilstrækkelig dokumentation</h4>
      <p>
        Hvis vi ikke kan afgøre:
      </p>
      <ul>
        <li>Vi kan ikke tvinge nogen til noget</li>
        <li>I må finde jeres egen løsning</li>
        <li>Vi kan give råd om næste skridt</li>
      </ul>

      <h3>Hvad DoMore kan gøre</h3>
      <ul>
        <li>✅ Mægle mellem jer</li>
        <li>✅ Give objektiv vurdering</li>
        <li>✅ Anbefale løsninger</li>
        <li>✅ Opdatere ratings</li>
        <li>✅ Advare brugere ved regelbryd</li>
        <li>✅ Bandlyse svindlere eller grove overtrædere</li>
        <li>✅ Vejlede om bedste praksis</li>
      </ul>

      <h3>Hvad DoMore IKKE kan gøre</h3>
      <ul>
        <li>❌ Fremtvinge betaling</li>
        <li>❌ Refundere med DoMore's penge</li>
        <li>❌ Fungere som politi eller domstol</li>
        <li>❌ Garantere et specifikt resulted</li>
        <li>❌ Erstatte beskadiget værktøj</li>
        <li>❌ Kompensere tab</li>
      </ul>

      <h3>Hvis du er utilfreds med vores afgørelse</h3>
      <p>
        Du kan:
      </p>
      <ul>
        <li>Anmode om at sagen genovervejes</li>
        <li>Medgive ny dokumentation vi ikke havde før</li>
        <li>Forklare misforståelser</li>
      </ul>

      <p>
        Ved alvorlige sager:
      </p>
      <ul>
        <li>Overvej juridisk rådgivning</li>
        <li>Kontakt Forbrugerombudsmanden</li>
        <li>Politi ved svindel eller tyveri</li>
      </ul>

      <h3>Juridiske skridt</h3>
      <p>
        DoMore er en platform og ikke ansvarlig for brugernes transaktioner.
      </p>

      <h4>Ved høje beløb</h4>
      <ul>
        <li>Overvej at kontakte en advokat</li>
        <li>Fogedretten kan hjælpe med inddrivelse</li>
        <li>Småsagdomstol for krav under 50.000 DKK</li>
      </ul>

      <h4>Ved svindel</h4>
      <ul>
        <li>Anmeld det til politiet</li>
        <li>Medgiv al dokumentation</li>
        <li>DoMore vil samarbejde med myndigheder</li>
      </ul>

      <h3>Forebyg tvister</h3>
      <p>
        De fleste problemer kan undgås:
      </p>
      <ul>
        <li>Kommunikér ALTID gennem DoMore (dokumentation)</li>
        <li>Tag billeder ved afhentning og returnering</li>
        <li>Aftal alt skriftligt</li>
        <li>Vær klar og specifik</li>
        <li>Dokumentér betaling</li>
        <li>Tjek ratings før booking</li>
        <li>Vær ærlig og pålidelig</li>
        <li>Respektér aftaler</li>
      </ul>

      <h3>Response tid</h3>
      <p>
        Vi stræber efter:
      </p>
      <ul>
        <li><strong>Akut:</strong> Svar samme dag (f.eks. sikkerhedstrusler)</li>
        <li><strong>Højprioritet:</strong> 24 timer (aktive tvister)</li>
        <li><strong>Normal:</strong> 1-3 hverdage</li>
        <li><strong>Lav prioritet:</strong> 3-5 hverdage (generelle spørgsmål)</li>
      </ul>

      <h3>Andre supportemner</h3>
      <p>
        Support hjælper også med:
      </p>
      <ul>
        <li>Tekniske problemer med appen</li>
        <li>Spørgsmål om funktioner</li>
        <li>Account problemer</li>
        <li>Feedback og forslag</li>
        <li>Rapportering af bugs</li>
      </ul>

      <h3>Vi er her for at hjælpe</h3>
      <p>
        Husk: Vores mål er et sikkert fællesskab hvor alle kan stole på hinanden. 
        Vi tager alle henvendelser seriøst og arbejder for fair løsninger.
      </p>
    </>
  );

  return (
    <HelpArticle
      title="Tvister og support"
      category="Betaling"
      content={content}
      relatedArticles={[
        { title: 'Betalingsproblemer', link: '/help/payment-problems' },
        { title: 'Sikker betaling', link: '/help/secure-payment' },
      ]}
    />
  );
};

export default DisputeSupport;
